
// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { TbRefresh } from "react-icons/tb";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
// } from "@mui/material";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const formattedCurrentDate = date.toISOString().split("T")[0];
//   const oneWeekAgo = new Date(date);
//   oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
//   const formattedOneWeekAgo = oneWeekAgo.toISOString().split("T")[0];
//   return {
//     Today: formattedCurrentDate,
//     LastWeek: formattedOneWeekAgo,
//   };
// }

// function  InvCufPerformance() {
//   const chartRef = useRef();
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//   const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);
//   const [metric, setMetric] = useState("CUF");
//   const [idealValue, setIdealValue] = useState(20);
//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: sessionStorage.getItem("LoginID"),
//     LOC_CODE: sessionStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // Fetch inverters and select first by default
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//           params: credentials,
//         });
//         const feederList = res.data.FEED || [];
//         setInverters(feederList);
//         // Select first inverter ID by default
//         if (feederList.length > 0) {
//           setSelectedKeys([feederList[0].feeder_id]);
//         }
//         setChartData(null);
//       } catch (err) {
//         console.error("Inverter API Error:", err);
//       }
//     }
//     fetchInverters();
//   }, []);

//   // Fetch chart data on refresh button click
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) {
//       setChartData(null);
//       return;
//     }
//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     // Always add Ideal Value dataset by default (no checkbox)
//     let idealLabels = [];
//     if (inverters.length > 0) {
//       try {
//         const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//           params: {
//             ...credentials,
//             MTR_NO: inverters[0].feeder_id,
//             DT1: fromDate,
//             DT2: toDate,  
//           },
//         });
//         const data = res.data.data || [];
//         idealLabels = data.map((d) => d.DATET);
//       } catch {
//         idealLabels = [];
//       }
//     }
//     labels = idealLabels.length ? idealLabels : [fromDate, toDate];
//     datasets.push({
//       label: "Ideal Value",
//       data: labels.map(() => Number(idealValue)),
//       borderColor: "red",
//       borderDash: [8, 4],
//       fill: false,
//       tension: 0,
//       borderWidth: 2,
//       pointRadius: 0,
//     });

//     for (const inv of inverters) {
//       if (!selectedKeys.includes(inv.feeder_id)) continue;

//       try {
//         const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//           params: {
//             ...credentials,
//             MTR_NO: inv.feeder_id,
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         });
//         const apiData = res.data.data || [];
//         if (!labels.length) {
//           labels = apiData.map((d) => d.DATET);
//         }
//         datasets.push({
//           label: inv.name,
//           data: apiData.map((d) => parseFloat(d[metric]) || 0),
//           borderColor: "#" + Math.floor(Math.random() * 16777215).toString(16),
//           fill: false,
//           tension: 0.3,
//         });
//       } catch {
//         // Handle errors silently
//       }
//     }

//     setChartData({ labels, datasets });
//     setLoading(false);
//   };

//   const handleToggle = (key) =>
//     setSelectedKeys((prev) =>
//       prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
//     );

//   // 🔁 Auto refresh chart when Ideal Value changes
//   useEffect(() => {
//     if (chartData) {
//       fetchChartData(); // Refresh the chart automatically
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [idealValue]);


//   return (
//     <div style={{ padding: "10px" }}>
//       <Box sx={{ mb: 1 }}>
//         <Typography variant="h5" fontWeight="bold">
//           Inverter Wise CUF Comparison
//         </Typography>
//       </Box>

//       <Paper elevation={2} sx={{ p: 2, mb: 2, bgcolor: "white" }}>
//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: 1,
//             alignItems: "center",
//             mb: 1,
//             fontSize: "0.75rem",
//           }}
//         >
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                   color="primary"
//                   sx={{
//                     p: 0.3,                // ✅ less padding
//                     transform: "scale(0.7)", // ✅ shrink size to 80%
//                   }}
//                 />
//               }
//               label={
//                 <Box
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 1,
//                     fontSize: "0.75rem",
//                   }}
//                 >
//                   <Typography variant="body2">{inv.name}</Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     [{inv.kwp} kWp]
//                   </Typography>
//                 </Box>
//               }
//             />
//           ))}
//         </Box>
//       </Paper>

//       <Box
//         sx={{
//           display: "flex",
//           flexWrap: "wrap",
//           gap: 1,
//           alignItems: "center",
//           mb: 1,
//         }}
//       >
//         <label style={{ fontSize: 14, fontWeight: 500 }}>Ideal Value:</label>
//         <TextField
//           size="small"
//           type="number"
//           sx={{ width: 70, fontSize: "0.75rem" }}
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <label style={{ fontSize: 14, fontWeight: 500 }}>From:</label>
//         <input
//           type="date"
//           value={fromDate}
//           onChange={(e) => setFromDate(e.target.value)}
//           style={{ height: 32, borderRadius: ".3rem" }}
//         />
//         <label style={{ fontSize: 14, fontWeight: 500 }}>To:</label>
//         <input
//           type="date"
//           value={toDate}
//           onChange={(e) => setToDate(e.target.value)}
//           style={{ height: 32, borderRadius: ".3rem" }}
//         />&nbsp;

//         <TbRefresh
//           style={{ fontSize: "1.5rem", cursor: "pointer" }}
//           onClick={fetchChartData}
//           title="Refresh Chart"
//         />

//         <DownloadJpegButton targetRef={chartRef} fileName={`Inverter Wise CUF Comparison.jpeg`} />
//       </Box>

//       <Paper ref={chartRef} sx={{ p: 2, bgcolor: "white", height: 350 }}>
//         {loading ? (
//           <Typography sx={{ textAlign: "center", mt: 12, color: "#999" }}>
//             Loading...
//           </Typography>
//         ) : chartData && chartData.labels.length > 0 && chartData.datasets.length > 0 ? (
//           <Line
//             data={chartData}
//             options={{
//               responsive: true,
//               maintainAspectRatio: false,
//               plugins: {
//                 legend: { position: "top", labels: { font: { size: 13 } } },
//               },
//               scales: {
//                 x: { ticks: { font: { size: 11 } } },
//                 y: { ticks: { font: { size: 11 } } },
//               },
//             }}
//           />
//         ) : (
//           <Typography sx={{ textAlign: "center", mt: 12, color: "#bbb" }}>
//             No data to display.
//           </Typography>
//         )}
//       </Paper>
//     </div>
//   );
// }

// export default InvCufPerformance;




// 2. correct code

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { TbRefresh } from "react-icons/tb";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
// } from "@mui/material";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// // 📅 Date helper
// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvCufPerformance() {
//   const chartRef = useRef();

//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);

//   const [fromDate, setFromDate] = useState(
//     getDateTimeForDashboardTab1().LastWeek
//   );
//   const [toDate, setToDate] = useState(
//     getDateTimeForDashboardTab1().Today
//   );

//   const [idealValue, setIdealValue] = useState(20);
//   const [loading, setLoading] = useState(false);

//   // ✅ Toggle (Line / Bar)
//   const [chartType, setChartType] = useState("line");

//   const credentials = {
//     LOGIN_ID: sessionStorage.getItem("LoginID"),
//     LOC_CODE: sessionStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           { params: credentials }
//         );

//         const list = res.data.FEED || [];
//         setInverters(list);

//         if (list.length > 0) {
//           setSelectedKeys([list[0].feeder_id]);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Fetch chart data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     // ✅ Ideal line
//     try {
//       const res = await axios.get(
//         `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//         {
//           params: {
//             ...credentials,
//             MTR_NO: selectedKeys[0],
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         }
//       );

//       const data = res.data.data || [];
//       labels = data.map((d) => d.DATET);

//       datasets.push({
//         label: "Ideal Value",
//         data: labels.map(() => Number(idealValue)),
//         borderColor: "red",
//         backgroundColor: "red",
//         borderDash: [6, 4],
//         tension: 0,
//         pointRadius: 0,
//         type: "line",
//       });
//     } catch {}

//     // ✅ Inverter data
//     for (const inv of inverters) {
//       if (!selectedKeys.includes(inv.feeder_id)) continue;

//       try {
//         const res = await axios.get(
//           `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//           {
//             params: {
//               ...credentials,
//               MTR_NO: inv.feeder_id,
//               DT1: fromDate,
//               DT2: toDate,
//             },
//           }
//         );

//         const apiData = res.data.data || [];

//         datasets.push({
//           label: inv.name,
//           data: apiData.map((d) => parseFloat(d.CUF) || 0),
//           borderColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           backgroundColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           tension: 0.4,
//           pointRadius: 2,
//         });
//       } catch {}
//     }

//     setChartData({ labels, datasets });
//     setLoading(false);
//   };

//   // 🔁 Ideal value change auto refresh
//   useEffect(() => {
//     if (chartData) fetchChartData();
//   }, [idealValue]);

//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   return (
//     <div style={{ padding: "10px" }}>
//       <Typography variant="h5" fontWeight="bold" mb={1}>
//         Inverter Wise CUF Comparison
//       </Typography>

//       {/* ✅ Inverter Selection */}
//       <Paper sx={{ p: 2, mb: 2 }}>
//         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                   sx={{ transform: "scale(0.7)" }}
//                 />
//               }
//               label={`${inv.name} [${inv.kwp} kWp]`}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* ✅ Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 1, alignItems: "center" }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <TbRefresh style={{ cursor: "pointer" }} onClick={fetchChartData} />

//         <DownloadJpegButton targetRef={chartRef} fileName="CUF Chart.jpeg" />
//       </Box>

//       {/* ✅ Toggle Button (Like your image) */}
//       <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
//         <Box
//           sx={{
//             display: "flex",
//             background: "#e0e0e0",
//             borderRadius: "20px",
//             p: "3px",
//           }}
//         >
//           <Box
//             onClick={() => setChartType("line")}
//             sx={{
//               px: 2,
//               py: 0.5,
//               cursor: "pointer",
//               borderRadius: "20px",
//               background: chartType === "line" ? "#1976d2" : "transparent",
//               color: chartType === "line" ? "#fff" : "#000",
//               fontSize: "0.8rem",
//             }}
//           >
//             📈 Line
//           </Box>

//           <Box
//             onClick={() => setChartType("bar")}
//             sx={{
//               px: 2,
//               py: 0.5,
//               cursor: "pointer",
//               borderRadius: "20px",
//               background: chartType === "bar" ? "#1976d2" : "transparent",
//               color: chartType === "bar" ? "#fff" : "#000",
//               fontSize: "0.8rem",
//             }}
//           >
//             📊 Bar
//           </Box>
//         </Box>
//       </Box>

//       {/* ✅ Chart */}
//       <Paper ref={chartRef} sx={{ p: 2, height: 350 }}>
//         {loading ? (
//           <Typography align="center" mt={10}>
//             Loading...
//           </Typography>
//         ) : chartData ? (
//           chartType === "line" ? (
//             <Line data={chartData} options={{ responsive: true, maintainAspectRatio: false }} />
//           ) : (
//             <Bar data={chartData} options={{ responsive: true, maintainAspectRatio: false }} />
//           )
//         ) : (
//           <Typography align="center" mt={10}>
//             No Data
//           </Typography>
//         )}
//       </Paper>
//     </div>
//   );
// }

// export default InvCufPerformance;



// 3.correct

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import { TbRefresh } from "react-icons/tb";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Switch,
// } from "@mui/material";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ChartDataLabels
// );

// // 📅 Date helper
// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvCufPerformance() {
//   const chartRef = useRef();

//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [isAllSelected, setIsAllSelected] = useState(false);
//   const [chartData, setChartData] = useState(null);

//   const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//   const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);

//   const [idealValue, setIdealValue] = useState(20);
//   const [loading, setLoading] = useState(false);

//   const [chartType, setChartType] = useState("bar");

//   const credentials = {
//     LOGIN_ID: sessionStorage.getItem("LoginID"),
//     LOC_CODE: sessionStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch Inverters
//   useEffect(() => {
//     async function fetchInverters() {
//       const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//         params: credentials,
//       });

//       const list = res.data.FEED || [];
//       setInverters(list);

//       if (list.length > 0) {
//         setSelectedKeys([list[0].feeder_id]);
//         setIsAllSelected(false);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All
//   const handleSelectAll = (e) => {
//     const checked = e.target.checked;
//     setIsAllSelected(checked);

//     if (checked) {
//       setSelectedKeys(inverters.map((i) => i.feeder_id));
//     } else {
//       setSelectedKeys([]);
//     }
//   };

//   // 🔹 Toggle
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) => {
//       const updated = prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key];

//       setIsAllSelected(updated.length === inverters.length);
//       return updated;
//     });
//   };

//   // 🔹 Fetch Data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//       params: {
//         ...credentials,
//         MTR_NO: selectedKeys[0],
//         DT1: fromDate,
//         DT2: toDate,
//       },
//     });

//     const data = res.data.data || [];
//     labels = data.map((d) => d.DATET);

//     for (const inv of inverters) {
//       if (!selectedKeys.includes(inv.feeder_id)) continue;

//       const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//         params: {
//           ...credentials,
//           MTR_NO: inv.feeder_id,
//           DT1: fromDate,
//           DT2: toDate,
//         },
//       });

//       const apiData = res.data.data || [];
//       const values = apiData.map((d) => parseFloat(d.CUF) || 0);

//       const colors = values.map((v) =>
//         v < idealValue ? "#e53935" : "#43a047"
//       );

//       datasets.push({
//         label: inv.name,
//         data: values,
//         backgroundColor: chartType === "horizontal" ? colors : "#1976d2",
//         borderColor: "#1976d2",
//       });
//     }

//     setChartData({ labels, datasets });
//     setLoading(false);
//   };

//   // Auto fetch on inverter change
//   useEffect(() => {
//     if (selectedKeys.length > 0) fetchChartData();
//   }, [selectedKeys]);

//   // ✅ Common Options
//   const commonOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     layout: { padding: { right: 20 } },
//     plugins: {
//       legend: {
//         position: "top",
//         labels: { font: { size: 12 } },
//       },
//     },
//   };

//   return (
//     <div style={{ padding: 10 }}>
//       <Typography variant="h5">Inverter Wise CUF</Typography>

//       {/* Select */}
//       <Paper sx={{ p: 2, mb: 2 }}>
//         <FormControlLabel
//           control={<Switch checked={isAllSelected} onChange={handleSelectAll} />}
//           label="Select All"
//         />

//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   size="small"
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <TbRefresh onClick={fetchChartData} style={{ cursor: "pointer" }} />

//         <DownloadJpegButton targetRef={chartRef} />
//       </Box>

//       {/* Tabs */}
//       <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
//         <Box sx={{ display: "flex", background: "#ddd", borderRadius: 20 }}>
//           {["bar", "horizontal", "line"].map((type) => (
//             <Box
//               key={type}
//               onClick={() => setChartType(type)}
//               sx={{
//                 px: 2,
//                 py: 0.5,
//                 cursor: "pointer",
//                 background: chartType === type ? "#1976d2" : "transparent",
//                 color: chartType === type ? "#fff" : "#000",
//                 borderRadius: 20,
//               }}
//             >
//               {type === "bar" && "📊 Bar"}
//               {type === "horizontal" && "📉 Horizontal"}
//               {type === "line" && "📈 Line"}
//             </Box>
//           ))}
//         </Box>
//       </Box>

//       {/* Chart */}
//       <Paper
//         ref={chartRef}
//         sx={{ p: 2, height: 400, overflow: "hidden" }}
//       >
//         {loading ? (
//           <Typography align="center">Loading...</Typography>
//         ) : chartData ? (
//           chartType === "line" ? (
//             <Line
//               data={chartData}
//               options={{
//                 ...commonOptions,
//                 elements: {
//                   line: { tension: 0.3 },
//                   point: { radius: 2 },
//                 },
//                 scales: {
//                   x: { ticks: { maxTicksLimit: 10 } },
//                   y: { beginAtZero: true },
//                 },
//               }}
//             />
//           ) : (
//             <Bar
//               data={chartData}
//               options={{
//                 ...commonOptions,
//                 indexAxis: chartType === "horizontal" ? "y" : "x",

//                 plugins: {
//                   ...commonOptions.plugins,
//                   datalabels: {
//                     display: chartType === "horizontal",
//                     color: "#000",
//                     anchor: "end",
//                     align: "right",
//                     clamp: true,
//                     formatter: (val) => val.toFixed(1),
//                   },
//                 },

//                 scales: {
//                   x: {
//                     ticks: { maxTicksLimit: 10 },
//                   },
//                   y: {
//                     ticks: { autoSkip: false },
//                   },
//                 },
//               }}
//             />
//           )
//         ) : (
//           <Typography>No Data</Typography>
//         )}
//       </Paper>
//     </div>
//   );
// }

// export default InvCufPerformance;


// 4.

// import React, { useState } from "react";
// import { Box, Typography, TextField } from "@mui/material";
// import { TbRefresh } from "react-icons/tb";

// import useInvCufData from "./useInvCufData";
// import BarChartPage from "./BarChartPage";
// import HorizontalChartPage from "./HorizontalChartPage";
// import LineChartPage from "./LineChartPage";
// import InvCufBarChart from "./invCufBarChart/InvCufBarChart";
// import InvCufHorizontalBarChart from "./invCufHorizontalBarChart/InvCufHorizontalBarChart";
// import InvLineChart from "./invLineChart/InvLineChart";

// export default function InvCufPerformance() {
//   const {
//     chartData,
//     fetchChartData,
//     idealValue,
//     setIdealValue,
//   } = useInvCufData();

//   const [tab, setTab] = useState("bar");

//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   return (
//     <div style={{ padding: 10 }}>
//       <Typography variant="h5">CUF Dashboard</Typography>

//       {/* Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <input type="date" onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" onChange={(e) => setToDate(e.target.value)} />

//         <TbRefresh onClick={() => fetchChartData(fromDate, toDate)} />
//       </Box>

//       {/* Tabs */}
//       <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//         <button onClick={() => setTab("bar")}>Bar</button>
//         <button onClick={() => setTab("horizontal")}>Horizontal</button>
//         <button onClick={() => setTab("line")}>Line</button>
//       </Box>

//       {/* Pages */}
//       {tab === "bar" && <InvCufBarChart chartData={chartData} />}
//       {tab === "horizontal" && (
//         <InvCufHorizontalBarChart chartData={chartData} idealValue={idealValue} />
//       )}
//       {tab === "line" && <InvLineChart chartData={chartData} />}
//     </div>
//   );
// }

// 5.

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Tabs,
//   Tab,
//   Switch,
// } from "@mui/material";
// import { TbRefresh } from "react-icons/tb";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ChartDataLabels
// );

// // 📅 Date helper
// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvCufPerformance() {
//   const chartRef = useRef();

//   const [tab, setTab] = useState(0);
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);

//   const [chartData, setChartData] = useState(null);
//   const [idealValue, setIdealValue] = useState(20);
//   const [loading, setLoading] = useState(false);

//   const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//   const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);

//   const credentials = {
//     LOGIN_ID: sessionStorage.getItem("LoginID"),
//     LOC_CODE: sessionStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch Inverters
//   useEffect(() => {
//     async function fetchInverters() {
//       const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//         params: credentials,
//       });

//       const list = res.data.FEED || [];
//       setInverters(list);

//       if (list.length > 0) {
//         setSelectedKeys([list[0].feeder_id]);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All
//   const handleSelectAll = (checked) => {
//     setSelectAll(checked);
//     if (checked) {
//       setSelectedKeys(inverters.map((i) => i.feeder_id));
//     } else {
//       setSelectedKeys([]);
//     }
//   };

//   // 🔹 Sync switch
//   useEffect(() => {
//     if (selectedKeys.length === inverters.length && inverters.length > 0) {
//       setSelectAll(true);
//     } else {
//       setSelectAll(false);
//     }
//   }, [selectedKeys, inverters]);

//   // 🔹 Toggle
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   // 🔹 Fetch Data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//       params: {
//         ...credentials,
//         MTR_NO: selectedKeys[0],
//         DT1: fromDate,
//         DT2: toDate,
//       },
//     });

//     const baseData = res.data.data || [];
//     labels = baseData.map((d) => d.DATET);

//     for (const inv of inverters) {
//       if (!selectedKeys.includes(inv.feeder_id)) continue;

//       const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//         params: {
//           ...credentials,
//           MTR_NO: inv.feeder_id,
//           DT1: fromDate,
//           DT2: toDate,
//         },
//       });

//       const apiData = res.data.data || [];

//       const dataMap = {};
//       apiData.forEach((d) => {
//         dataMap[d.DATET] = parseFloat(d.CUF) || 0;
//       });

//       datasets.push({
//         label: inv.name,
//         data: labels.map((label) => dataMap[label] || 0),
//         borderColor: "#1976d2",
//         backgroundColor: "#1976d2",
//       });
//     }

//     setChartData({ labels, datasets });
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchChartData();
//   }, [selectedKeys, idealValue]);

//   // 🔹 Options
//   const commonOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: { datalabels: { display: false } },
//   };

//   const lineOptions = {
//     ...commonOptions,
//     scales: { y: { beginAtZero: true } },
//   };

//   const horizontalBarOptions = {
//     ...commonOptions,
//     indexAxis: "y",
//     plugins: {
//       datalabels: {
//         display: true,
//         anchor: "end",
//         align: "right",
//         formatter: (val) => val.toFixed(1),
//       },
//     },
//   };

//   return (
//     <div style={{ padding: 10 }}>
//       {/* 🔹 Header */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 2,
//           flexWrap: "wrap",
//         }}
//       >
//         <Typography variant="h5" fontWeight="bold">
//           Inverter Wise CUF
//         </Typography>

//         <Tabs value={tab} onChange={(e, v) => setTab(v)}>
//           <Tab label="Bar Chart" />
//           <Tab label="Horizontal Bar" />
//           <Tab label="Line Chart" />
//         </Tabs>
//       </Box>

//       {/* 🔹 Select */}
//       <Paper sx={{ p: 2, mb: 2 }}>
//         <FormControlLabel
//           control={<Switch checked={selectAll} onChange={(e) => handleSelectAll(e.target.checked)} />}
//           label="Select All"
//         />

//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* 🔹 Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <TbRefresh
//           size={30}
//           onClick={fetchChartData}
//           style={{ cursor: "pointer", color: "#1976d2", transition: "0.3s" }}
//           onMouseOver={(e) => (e.currentTarget.style.transform = "rotate(90deg)")}
//           onMouseOut={(e) => (e.currentTarget.style.transform = "rotate(0deg)")}
//         />

//         <DownloadJpegButton targetRef={chartRef} />
//       </Box>

//       {/* 🔹 Chart */}
//       <Paper ref={chartRef} sx={{ p: 2 }}>
//         <Box sx={{ height: "300px" }}>
//           {loading ? (
//             <Typography align="center">Loading...</Typography>
//           ) : chartData ? (
//             <>
//               {tab === 0 && <Bar data={chartData} options={commonOptions} />}
//               {tab === 1 && <Bar data={chartData} options={horizontalBarOptions} />}
//               {tab === 2 && <Line data={chartData} options={lineOptions} />}
//             </>
//           ) : (
//             <Typography>No Data</Typography>
//           )}
//         </Box>
//       </Paper>
//     </div>
//   );
// }

// export default InvCufPerformance;

// 6. CORRECT YESTERDAY CODE

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Tabs,
//   Tab,
//   Switch,
// } from "@mui/material";
// import { TbRefresh } from "react-icons/tb";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ChartDataLabels
// );

// // 🎨 Color Palette
// const colorPalette = [
//   "#1976d2", "#2e7d32", "#ed6c02", "#9c27b0",
//   "#d32f2f", "#0288d1", "#7b1fa2", "#388e3c",
//   "#f57c00", "#c2185b"
// ];

// // 📅 Date helper
// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvCufPerformance() {
//   const chartRef = useRef();

//   const [tab, setTab] = useState(0);
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);

//   const [chartData, setChartData] = useState(null);
//   const [idealValue, setIdealValue] = useState(20);
//   const [loading, setLoading] = useState(false);

//   const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//   const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);

//   const credentials = {
//     LOGIN_ID: sessionStorage.getItem("LoginID"),
//     LOC_CODE: sessionStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch Inverters
//   useEffect(() => {
//     async function fetchInverters() {
//       const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//         params: credentials,
//       });

//       const list = res.data.FEED || [];
//       setInverters(list);

//       if (list.length > 0) {
//         setSelectedKeys([list[0].feeder_id]);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All
//   const handleSelectAll = (checked) => {
//     setSelectAll(checked);
//     if (checked) {
//       setSelectedKeys(inverters.map((i) => i.feeder_id));
//     } else {
//       setSelectedKeys([]);
//     }
//   };

//   // 🔹 Sync switch
//   useEffect(() => {
//     setSelectAll(
//       selectedKeys.length === inverters.length && inverters.length > 0
//     );
//   }, [selectedKeys, inverters]);

//   // 🔹 Toggle
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   // 🔹 Fetch Data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//       params: {
//         ...credentials,
//         MTR_NO: selectedKeys[0],
//         DT1: fromDate,
//         DT2: toDate,
//       },
//     });

//     const baseData = res.data.data || [];
//     labels = baseData.map((d) => d.DATET);

//     // 🔴 Ideal Line (only for line chart)
//     datasets.push({
//       label: "Ideal",
//       data: labels.map(() => Number(idealValue)),
//       borderColor: "red",
//       backgroundColor: "red",
//       borderDash: [5, 5],
//       tension: 0,
//       pointRadius: 0,
//       fill: false,
//     });

//     for (let i = 0; i < inverters.length; i++) {
//       const inv = inverters[i];
//       if (!selectedKeys.includes(inv.feeder_id)) continue;

//       const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//         params: {
//           ...credentials,
//           MTR_NO: inv.feeder_id,
//           DT1: fromDate,
//           DT2: toDate,
//         },
//       });

//       const apiData = res.data.data || [];

//       const dataMap = {};
//       apiData.forEach((d) => {
//         dataMap[d.DATET] = parseFloat(d.CUF) || 0;
//       });

//       const values = labels.map((label) => dataMap[label] || 0);

//       // 🔥 Red/Green logic
//       const dynamicColors = values.map((v) =>
//         v < idealValue ? "#e53935" : "#43a047"
//       );

//       datasets.push({
//         label: inv.name,
//         data: values,
//         borderColor: colorPalette[i % colorPalette.length],
//         backgroundColor:
//           tab === 1
//             ? dynamicColors
//             : colorPalette[i % colorPalette.length],
//         tension: 0.4,
//         pointRadius: 3,
//         fill: false,
//       });
//     }

//     setChartData({ labels, datasets });
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchChartData();
//   }, [selectedKeys, idealValue]);

//   // 🔹 Options
//   const commonOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: { datalabels: { display: false } },
//   };

//   const lineOptions = {
//     ...commonOptions,
//     scales: { y: { beginAtZero: true } },
//   };

//   const horizontalBarOptions = {
//     ...commonOptions,
//     indexAxis: "y",
//     plugins: {
//       datalabels: {
//         display: true,
//         anchor: "end",
//         align: "right",
//         formatter: (val) => val.toFixed(1),
//       },
//     },
//   };

//   return (
//     <div style={{ padding: 10 }}>
//       {/* 🔹 Header */}
//       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//         <Typography variant="h5" fontWeight="bold">
//           Inverter Wise CUF
//         </Typography>

//         <Tabs value={tab} onChange={(e, v) => setTab(v)}>
//           <Tab label="Bar Chart" />
//           <Tab label="Horizontal Bar" />
//           <Tab label="Line Chart" />
//         </Tabs>
//       </Box>

//       {/* 🔹 Select */}
//       <Paper sx={{ p: 2, mb: 2 }}>
//         <FormControlLabel
//           control={<Switch checked={selectAll} onChange={(e) => handleSelectAll(e.target.checked)} />}
//           label="Select All"
//         />

//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* 🔹 Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <TbRefresh
//           size={30}
//           onClick={fetchChartData}
//           style={{ cursor: "pointer", color: "#1976d2", transition: "0.3s" }}
//           onMouseOver={(e) => (e.currentTarget.style.transform = "rotate(90deg)")}
//           onMouseOut={(e) => (e.currentTarget.style.transform = "rotate(0deg)")}
//         />

//         <DownloadJpegButton targetRef={chartRef} />
//       </Box>

//       {/* 🔹 Chart */}
//       <Paper ref={chartRef} sx={{ p: 2 }}>
//         <Box sx={{ height: "300px" }}>
//           {loading ? (
//             <Typography align="center">Loading...</Typography>
//           ) : chartData ? (
//             <>
//               {tab === 0 && <Bar data={chartData} options={commonOptions} />}
//               {tab === 1 && <Bar data={chartData} options={horizontalBarOptions} />}
//               {tab === 2 && <Line data={chartData} options={lineOptions} />}
//             </>
//           ) : (
//             <Typography>No Data</Typography>
//           )}
//         </Box>
//       </Paper>
//     </div>
//   );
// }

// export default InvCufPerformance;

// 7

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Tabs,
//   Tab,
//   Switch,
// } from "@mui/material";
// import { TbRefresh } from "react-icons/tb";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// // ❌ Removed ChartDataLabels from global
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// // 🎨 Color Palette
// const colorPalette = [
//   "#1976d2", "#2e7d32", "#ed6c02", "#9c27b0",
//   "#d32f2f", "#0288d1", "#7b1fa2", "#388e3c",
//   "#f57c00", "#c2185b"
// ];

// // 📅 Date helper
// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvCufPerformance() {
//   const chartRef = useRef();

//   const [tab, setTab] = useState(0);
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);

//   const [chartData, setChartData] = useState(null);
//   const [idealValue, setIdealValue] = useState(20);
//   const [loading, setLoading] = useState(false);

//   const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//   const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);

//   const credentials = {
//     LOGIN_ID: sessionStorage.getItem("LoginID"),
//     LOC_CODE: sessionStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch Inverters
//   useEffect(() => {
//     async function fetchInverters() {
//       const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//         params: credentials,
//       });

//       const list = res.data.FEED || [];
//       setInverters(list);

//       if (list.length > 0) {
//         setSelectedKeys([list[0].feeder_id]);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All
//   const handleSelectAll = (checked) => {
//     setSelectAll(checked);
//     if (checked) {
//       setSelectedKeys(inverters.map((i) => i.feeder_id));
//     } else {
//       setSelectedKeys([]);
//     }
//   };

//   // 🔹 Sync switch
//   useEffect(() => {
//     setSelectAll(
//       selectedKeys.length === inverters.length && inverters.length > 0
//     );
//   }, [selectedKeys, inverters]);

//   // 🔹 Toggle
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   // 🔹 Fetch Data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//       params: {
//         ...credentials,
//         MTR_NO: selectedKeys[0],
//         DT1: fromDate,
//         DT2: toDate,
//       },
//     });

//     const baseData = res.data.data || [];
//     labels = baseData.map((d) => d.DATET);

//     // Ideal Line
//     datasets.push({
//       label: "Ideal",
//       data: labels.map(() => Number(idealValue)),
//       borderColor: "red",
//       backgroundColor: "red",
//       borderDash: [5, 5],
//       tension: 0,
//       pointRadius: 0,
//       fill: false,
//     });

//     for (let i = 0; i < inverters.length; i++) {
//       const inv = inverters[i];
//       if (!selectedKeys.includes(inv.feeder_id)) continue;

//       const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//         params: {
//           ...credentials,
//           MTR_NO: inv.feeder_id,
//           DT1: fromDate,
//           DT2: toDate,
//         },
//       });

//       const apiData = res.data.data || [];

//       const dataMap = {};
//       apiData.forEach((d) => {
//         dataMap[d.DATET] = parseFloat(d.CUF) || 0;
//       });

//       const values = labels.map((label) => dataMap[label] || 0);

//       const dynamicColors = values.map((v) =>
//         v < idealValue ? "#e53935" : "#43a047"
//       );

//       datasets.push({
//         label: inv.name,
//         data: values,
//         borderColor: colorPalette[i % colorPalette.length],
//         backgroundColor:
//           tab === 1
//             ? dynamicColors
//             : colorPalette[i % colorPalette.length],
//         tension: 0.4,
//         pointRadius: 3,
//         fill: false,
//       });
//     }

//     setChartData({ labels, datasets });
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchChartData();
//   }, [selectedKeys, idealValue]);

//   // 🔹 Common Options
//   const commonOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       datalabels: { display: false }, // ✅ disable globally
//     },
//   };

//   const lineOptions = {
//     ...commonOptions,
//     scales: { y: { beginAtZero: true } },
//   };

//   const barOptions = {
//     ...commonOptions,
//   };

//   // ✅ Horizontal Bar Options (ONLY HERE LABEL SHOW)
//   const horizontalBarOptions = {
//     ...commonOptions,
//     indexAxis: "y",
//     plugins: {
//       datalabels: {
//         display: true,
//         anchor: "end",
//         align: "right",
//         formatter: (value) =>
//           value ? Number(value).toFixed(1) : "0",
//         color: (context) => {
//           const val = context.raw;
//           return val < idealValue ? "#e53935" : "#2e7d32";
//         },
//         font: {
//           weight: "bold",
//         },
//       },
//     },
//   };

//   return (
//     <div style={{ padding: 10 }}>
//       {/* Header */}
//       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//         <Typography variant="h5" fontWeight="bold">
//           Inverter Wise CUF
//         </Typography>

//         <Tabs value={tab} onChange={(e, v) => setTab(v)}>
//           <Tab label="Bar Chart" />
//           <Tab label="Horizontal Bar" />
//           <Tab label="Line Chart" />
//         </Tabs>
//       </Box>

//       {/* Select */}
//       <Paper sx={{ p: 2, mb: 2 }}>
//         <FormControlLabel
//           control={
//             <Switch
//               checked={selectAll}
//               onChange={(e) => handleSelectAll(e.target.checked)}
//             />
//           }
//           label="Select All"
//         />

//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <input
//           type="date"
//           value={fromDate}
//           onChange={(e) => setFromDate(e.target.value)}
//         />
//         <input
//           type="date"
//           value={toDate}
//           onChange={(e) => setToDate(e.target.value)}
//         />

//         <TbRefresh
//           size={30}
//           onClick={fetchChartData}
//           style={{ cursor: "pointer", color: "#1976d2" }}
//         />

//         <DownloadJpegButton targetRef={chartRef} />
//       </Box>

//       {/* Chart */}
//       <Paper ref={chartRef} sx={{ p: 2 }}>
//         <Box sx={{ height: "300px" }}>
//           {loading ? (
//             <Typography align="center">Loading...</Typography>
//           ) : chartData ? (
//             <>
//               {tab === 0 && <Bar data={chartData} options={barOptions} />}

//               {tab === 1 && (
//                 <Bar
//                   data={chartData}
//                   options={horizontalBarOptions}
//                   plugins={[ChartDataLabels]} // ✅ only here
//                 />
//               )}

//               {tab === 2 && <Line data={chartData} options={lineOptions} />}
//             </>
//           ) : (
//             <Typography>No Data</Typography>
//           )}
//         </Box>
//       </Paper>
//     </div>
//   );
// }

// export default InvCufPerformance;

// 8. ideal line me

import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Line, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import annotationPlugin from "chartjs-plugin-annotation";
import {
  Paper,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
  Tabs,
  Tab,
  Switch,
} from "@mui/material";
import { TbRefresh } from "react-icons/tb";
import { BaseUrl } from "../../../../../../api/AxiosApi";
import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ✅ Register plugins
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  annotationPlugin
);

// 🎨 Color Palette
const colorPalette = [
  "#1976d2","#2e7d32","#ed6c02","#9c27b0",
  "#d32f2f","#0288d1","#7b1fa2","#388e3c"
];

function getDateTimeForDashboardTab1(date = new Date()) {
  const today = date.toISOString().split("T")[0];
  const lastWeek = new Date(date);
  lastWeek.setDate(lastWeek.getDate() - 7);

  return {
    Today: today,
    LastWeek: lastWeek.toISOString().split("T")[0],
  };
}

// function InvCufPerformance() {
//   const chartRef = useRef();

//   const [tab, setTab] = useState(0);
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);

//   const [chartData, setChartData] = useState(null);
//   const [idealValue, setIdealValue] = useState(20);
//   const [loading, setLoading] = useState(false);

//   const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//   const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);

//   const credentials = {
//     LOGIN_ID: sessionStorage.getItem("LoginID"),
//     LOC_CODE: sessionStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch Inverters
//   useEffect(() => {
//     async function fetchInverters() {
//       const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//         params: credentials,
//       });

//       const list = res.data.FEED || [];
//       setInverters(list);

//       if (list.length > 0) {
//         setSelectedKeys([list[0].feeder_id]);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All
//   const handleSelectAll = (checked) => {
//     setSelectAll(checked);
//     setSelectedKeys(
//       checked ? inverters.map((i) => i.feeder_id) : []
//     );
//   };

//   useEffect(() => {
//     setSelectAll(
//       selectedKeys.length === inverters.length &&
//         inverters.length > 0
//     );
//   }, [selectedKeys, inverters]);

//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   // 🔹 Fetch Data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     try {
//       let labels = [];
//       let datasets = [];

//       const baseRes = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//         params: {
//           ...credentials,
//           MTR_NO: selectedKeys[0],
//           DT1: fromDate,
//           DT2: toDate,
//         },
//       });

//       const baseData = baseRes.data.data || [];
//       labels = baseData.map((d) => d.DATET);

//       for (let i = 0; i < inverters.length; i++) {
//         const inv = inverters[i];
//         if (!selectedKeys.includes(inv.feeder_id)) continue;

//         const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//           params: {
//             ...credentials,
//             MTR_NO: inv.feeder_id,
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         });

//         const apiData = res.data.data || [];

//         const dataMap = {};
//         apiData.forEach((d) => {
//           dataMap[d.DATET] = parseFloat(d.CUF) || 0;
//         });

//         datasets.push({
//           label: inv.name,
//           data: labels.map((l) => dataMap[l] || 0),
//           borderColor: colorPalette[i % colorPalette.length],
//           backgroundColor: colorPalette[i % colorPalette.length],
//           tension: 0.4,
//           pointRadius: 3,
//         });
//       }

//       setChartData({ labels, datasets });
//     } catch (err) {
//       console.error(err);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchChartData();
//   }, [selectedKeys, idealValue]);

//   // 🔥 Ideal Lines
//   const idealLineY = {
//     type: "line",
//     yMin: idealValue,
//     yMax: idealValue,
//     borderColor: "red",
//     borderWidth: 2,
//     borderDash: [6, 6],
//     label: {
//       display: true,
//       content: `Ideal: ${idealValue}`,
//     },
//   };

//   const idealLineX = {
//     type: "line",
//     xMin: idealValue,
//     xMax: idealValue,
//     borderColor: "red",
//     borderWidth: 2,
//     borderDash: [6, 6],
//     label: {
//       display: true,
//       content: `Ideal: ${idealValue}`,
//     },
//   };

//   const commonOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       datalabels: { display: false },
//     },
//   };

//   const barOptions = {
//     ...commonOptions,
//     scales: { y: { beginAtZero: true, max: 100 } },
//     plugins: {
//       ...commonOptions.plugins,
//       annotation: { annotations: { ideal: idealLineY } },
//     },
//   };

//   const horizontalBarOptions = {
//     ...commonOptions,
//     indexAxis: "y",
//     scales: { x: { beginAtZero: true, max: 100 } },
//     plugins: {
//       datalabels: {
//         display: true,
//         anchor: "end",
//         align: "right",
//         formatter: (v) => v.toFixed(1),
//       },
//       annotation: { annotations: { ideal: idealLineX } },
//     },
//   };

//   const lineOptions = {
//     ...commonOptions,
//     scales: { y: { beginAtZero: true, max: 100 } },
//     plugins: {
//       ...commonOptions.plugins,
//       annotation: { annotations: { ideal: idealLineY } },
//     },
//   };

//   return (
//     <div style={{ padding: 10 }}>
//       <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//         <Typography variant="h5">Inverter Wise CUF Comparison</Typography>

//         <Tabs value={tab} onChange={(e, v) => setTab(v)}>
//           <Tab label="Bar" />
//           <Tab label="Horizontal" />
//           <Tab label="Line" />
//         </Tabs>
//       </Box>

//       {/* Selection */}
//       <Paper sx={{ p: 2, my: 2 }}>
//         <FormControlLabel
//           control={<Switch checked={selectAll} onChange={(e) => handleSelectAll(e.target.checked)} />}
//           label="Select All"
//         />

//         <Box sx={{ display: "flex", flexWrap: "wrap", maxHeight: 150, overflowY: "auto" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         {/* <TbRefresh onClick={fetchChartData} style={{ cursor: "pointer" }} /> */}
//         <TbRefresh 
//   onClick={fetchChartData} 
//   style={{ cursor: "pointer", fontSize: "28px" }} 
// />
//         <DownloadJpegButton targetRef={chartRef} />
//       </Box>

//       {/* Chart */}
//       <Paper ref={chartRef} sx={{ p: 2 }}>
//         <Box sx={{ height: 300 }}>
//           {loading ? (
//             <Typography align="center">Loading...</Typography>
//           ) : chartData ? (
//             <>
//               {tab === 0 && <Bar data={chartData} options={barOptions} />}
//               {tab === 1 && (
//                 <Bar
//                   data={chartData}
//                   options={horizontalBarOptions}
//                   plugins={[ChartDataLabels]}
//                 />
//               )}
//               {tab === 2 && <Line data={chartData} options={lineOptions} />}
//             </>
//           ) : (
//             <Typography align="center">No Data</Typography>
//           )}
//         </Box>
//       </Paper>
//     </div>
//   );
// }

// export default InvCufPerformance;

// ... all imports and ChartJS registration remain the same

function InvCufPerformance() {
  const chartRef = useRef();

  const [tab, setTab] = useState(0);
  const [inverters, setInverters] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [chartData, setChartData] = useState(null);
  const [idealValue, setIdealValue] = useState(20);
  const [loading, setLoading] = useState(false);

  // 🔹 Added Date Pickers
  const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
  const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);

  const credentials = {
    LOGIN_ID: sessionStorage.getItem("LoginID"),
    LOC_CODE: sessionStorage.getItem("LCODE"),
    PASS_KEY: "XYZ",
    WEB_KEY: "WEBXYZ321",
    TYP: "I",
  };

  // 🔹 Fetch Inverters
  useEffect(() => {
    async function fetchInverters() {
      const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, { params: credentials });
      const list = res.data.FEED || [];
      setInverters(list);

      if (list.length > 0) {
        setSelectedKeys([list[0].feeder_id]);
      }
    }

    fetchInverters();
  }, []);

  // 🔹 Select All
  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    setSelectedKeys(checked ? inverters.map((i) => i.feeder_id) : []);
  };

  useEffect(() => {
    setSelectAll(selectedKeys.length === inverters.length && inverters.length > 0);
  }, [selectedKeys, inverters]);

  const handleToggle = (key) => {
    setSelectedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  // 🔹 Fetch Chart Data
  const fetchChartData = async () => {
    if (selectedKeys.length === 0) return;
    setLoading(true);

    try {
      let labels = [];
      let datasets = [];

      const baseRes = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
        params: { ...credentials, MTR_NO: selectedKeys[0], DT1: fromDate, DT2: toDate },
      });

      const baseData = baseRes.data.data || [];
      labels = baseData.map((d) => d.DATET);

      for (let i = 0; i < inverters.length; i++) {
        const inv = inverters[i];
        if (!selectedKeys.includes(inv.feeder_id)) continue;

        const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
          params: { ...credentials, MTR_NO: inv.feeder_id, DT1: fromDate, DT2: toDate },
        });

        const apiData = res.data.data || [];
        const dataMap = {};
        apiData.forEach((d) => { dataMap[d.DATET] = parseFloat(d.CUF) || 0; });

        datasets.push({
          label: inv.name,
          data: labels.map((l) => dataMap[l] || 0),
          borderColor: colorPalette[i % colorPalette.length],
          backgroundColor: colorPalette[i % colorPalette.length],
          tension: 0.4,
          pointRadius: 3,
        });
      }

      setChartData({ labels, datasets });
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchChartData();
  }, [selectedKeys, idealValue, fromDate, toDate]); // 🔹 Added date dependency

  // 🔹 Ideal Lines & Options remain the same
  const idealLineY = { type: "line", yMin: idealValue, yMax: idealValue, borderColor: "red", borderWidth: 2, borderDash: [6, 6], label: { display: true, content: `Ideal: ${idealValue}` } };
  const idealLineX = { type: "line", xMin: idealValue, xMax: idealValue, borderColor: "red", borderWidth: 2, borderDash: [6, 6], label: { display: true, content: `Ideal: ${idealValue}` } };
  const commonOptions = { responsive: true, maintainAspectRatio: false, plugins: { datalabels: { display: false } } };
  const barOptions = { ...commonOptions, scales: { y: { beginAtZero: true, max: 100 } }, plugins: { ...commonOptions.plugins, annotation: { annotations: { ideal: idealLineY } } } };
  const horizontalBarOptions = { ...commonOptions, indexAxis: "y", scales: { x: { beginAtZero: true, max: 100 } }, plugins: { datalabels: { display: true, anchor: "end", align: "right", formatter: (v) => v.toFixed(1) }, annotation: { annotations: { ideal: idealLineX } } } };
  const lineOptions = { ...commonOptions, scales: { y: { beginAtZero: true, max: 100 } }, plugins: { ...commonOptions.plugins, annotation: { annotations: { ideal: idealLineY } } } };

  return (
    <div style={{ padding: 10 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h5">Inverter Wise CUF Comparison</Typography>
        <Tabs value={tab} onChange={(e, v) => setTab(v)}>
          <Tab label="Bar" />
          <Tab label="Horizontal" />
          <Tab label="Line" />
        </Tabs>
      </Box>

      {/* Selection */}
      <Paper sx={{ p: 2, my: 2 }}>
        <FormControlLabel control={<Switch checked={selectAll} onChange={(e) => handleSelectAll(e.target.checked)} />} label="Select All" />
        <Box sx={{ display: "flex", flexWrap: "wrap", maxHeight: 150, overflowY: "auto" }}>
          {inverters.map((inv) => (
            <FormControlLabel key={inv.feeder_id} control={<Checkbox checked={selectedKeys.includes(inv.feeder_id)} onChange={() => handleToggle(inv.feeder_id)} />} label={inv.name} />
          ))}
        </Box>
      </Paper>

      {/* Controls */}
      <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
        {/* 🔹 Date Pickers */}
        <TextField
          size="small"
          label="From"
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          size="small"
          label="To"
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />

        <TextField size="small" label="Ideal" type="number" value={idealValue} onChange={(e) => setIdealValue(e.target.value)} />
        <TbRefresh onClick={fetchChartData} style={{ cursor: "pointer", fontSize: "28px" }} />
        <DownloadJpegButton targetRef={chartRef} />
      </Box>

      {/* Chart */}
      <Paper ref={chartRef} sx={{ p: 2 }}>
        <Box sx={{ height: 300 }}>
          {loading ? <Typography align="center">Loading...</Typography> : chartData ? (
            <>
              {tab === 0 && <Bar data={chartData} options={barOptions} />}
              {tab === 1 && <Bar data={chartData} options={horizontalBarOptions} plugins={[ChartDataLabels]} />}
              {tab === 2 && <Line data={chartData} options={lineOptions} />}
            </>
          ) : <Typography align="center">No Data</Typography>}
        </Box>
      </Paper>
    </div>
  );     
}

export default InvCufPerformance;                                                                                                                                     